// extracted by mini-css-extract-plugin
export default {"formContainer":"appraisal-editor_formContainer__jFgnS"};